export default __webpack_public_path__ + "static/media/54_mobile.ad9d0a20.jpg";